export default "__VITE_ASSET__C_L5PDZz__"